import { useEffect, useState } from 'react';

export function useIsLive(startIso: string) {
  const start = new Date(startIso).getTime();
  const [isLive, setIsLive] = useState(() => Date.now() >= start);

  useEffect(() => {
    if (isLive) return;
    const remaining = start - Date.now();
    // Unlock exactly at start time; re-check every minute as a fallback for sleeping tabs.
    const timeout = window.setTimeout(() => setIsLive(true), Math.min(remaining, 2147483647));
    const interval = window.setInterval(() => {
      if (Date.now() >= start) setIsLive(true);
    }, 60000);
    return () => {
      window.clearTimeout(timeout);
      window.clearInterval(interval);
    };
  }, [isLive, start]);

  return isLive;
}
